export default "__VITE_ASSET__CaR7iPBh__"